// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6":"d39aba52cfbc902d","735":"4be63a2b82bd420c","790":"bdc569ddcf9ebaaa"}[chunkId] + ".js";
};